let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ht45y")).then(() => parcelRequire('1gUfY'));